import { useEffect, useState } from "react";
import Bookmarks from "../Lookup/Bookmarks";
import { auth0Config } from "../../Config/auth0Conifg";
import { useAuth0 } from "@auth0/auth0-react";
import { Col, Container, Row } from "react-bootstrap";

export default function History() {
  const [token, setToken] = useState<string | null>(null);
  const { getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    getAccessTokenSilently({
      authorizationParams: {
        audience: auth0Config.audience,
      },
    }).then((accessToken) => {
      setToken(accessToken);
    });
  }, []);
  return (
    <div className="page-history">
      <Container>
        <Row className="justify-content-center">
          <Col lg={6}>
            <h1>History</h1>
            {token && (
              <>
                <Bookmarks token={token} paginate={true} />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
